import { Action } from 'typescript-fsa';
import * as actions from './actions';
import { Dispatch } from 'redux';
import { createEndpoint, deleteEndpoint } from '../../../apis';
import { loadingOperations } from '../loading';
import { getLogger } from '../../../utils';
import { systemStateMessageOperations } from '..';

const launchEndpoint = (params: { koujiBangou: string, operationKey: string }) => async (dispatch: Dispatch<Action<any>>) => {
  loadingOperations.startLoading()(dispatch);

  try {
    dispatch(actions.launchEndpoint.started(params));
    const result = await createEndpoint(params);
    dispatch(actions.launchEndpoint.done({ params, result }));
  } catch (error) {
    dispatch(actions.launchEndpoint.failed({ params, error: error.toString() }))
    getLogger().error('endpointOperation/list()', error);
    systemStateMessageOperations.putError({ message: '通信エラーが発生しました。' })(dispatch);
  } finally {
    loadingOperations.stopLoading()(dispatch);
  }
}
const stopEndpoint = (params: { koujiBangou: string, operationKey: string }) => async (dispatch: Dispatch<Action<any>>) => {
  loadingOperations.startLoading()(dispatch);

  try {
    dispatch(actions.stopEndpoint.started(params));
    const result = await deleteEndpoint(params);
    dispatch(actions.stopEndpoint.done({ params, result }));
  } catch (error) {
    dispatch(actions.stopEndpoint.failed({ params, error: error.toString() }))
    getLogger().error('endpointOperation/list()', error);
    systemStateMessageOperations.putError({ message: '通信エラーが発生しました。' })(dispatch);
  } finally {
    loadingOperations.stopLoading()(dispatch);
  }
}

export {
  launchEndpoint,
  stopEndpoint
};



// WEBPACK FOOTER //
// ./src/redux/modules/endpointOperation/operations.ts